import { action, makeObservable, observable } from 'mobx';
import { Service } from 'typedi';
import { BaseViewModel } from '../../../../core/services/BaseViewModel';
import { Appl } from '../../../../core/Appl';
import { AuthContext } from '../../../../core/services/AuthContext';
import { AuthProvider } from '../../../../core/services/IUserContext';
import { ServerResponse } from '../../../../core/services/BaseService';

@Service()
export default class LoginViewModel extends BaseViewModel {
  constructor() {
    super();
    makeObservable(this);
  }

  @action public async initAsync() {
    this.pageTitle = 'SCERS - Login';
    Appl.Spinner.show();
    // let authenticated = await Appl.User.isAuthenticatedAsync();
    let authenticated = Appl.User.isAuthenticated;
    if (authenticated) {
      this.navigate('/dashboard');
    }
    Appl.Spinner.hide();
  }

  @action public async loginAsync(authProvider: AuthProvider = "AzureAD") {
    let result: ServerResponse;
    result = await AuthContext.instance.signInAsync(authProvider, "", "");
    //Below Code will NOT trigger if we use Inline Azure AD Authentication
    if (result.success) {
      window.location.assign(`/dashboard`);
    } else {
      Appl.Error.handle(result.data);
    }
  }
}
